import React from 'react';

export const SLA_LABEL = {
  green: 'SLA Met',
  none: 'In Progress',
  yellow: 'SLA Breached',
  red: 'Critical Delay'
};

export const SLA_DOT_CLASS = {
  green: 'bg-green-500',
  none: 'bg-transparent border border-gray-300',
  yellow: 'bg-yellow-400',
  red: 'bg-red-500'
};

export function getSlaColorKey(slaColor) {
  const key = String(slaColor ?? 'none').trim().toLowerCase();
  return Object.prototype.hasOwnProperty.call(SLA_DOT_CLASS, key) ? key : 'none';
}

/**
 * Colored SLA status dot for prelead list rows.
 * Maps API `sla_color`: green | none | yellow | red
 */
const PreleadSlaIndicator = ({ slaColor, className = '' }) => {
  const key = getSlaColorKey(slaColor);
  const label = SLA_LABEL[key];

  return (
    <span
      className={`inline-block h-2.5 w-2.5 shrink-0 rounded-full ${SLA_DOT_CLASS[key]} ${className}`.trim()}
      title={label}
      aria-label={label}
      role="img"
    />
  );
};

export default PreleadSlaIndicator;
